module.exports = __webpack_public_path__ + "static/media/notes.495d8c4e.svg";